import { render, staticRenderFns } from "./CaseFilters.vue?vue&type=template&id=8c6a84b2&scoped=true&"
import script from "./CaseFilters.vue?vue&type=script&lang=ts&"
export * from "./CaseFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFilters.vue?vue&type=style&index=0&id=8c6a84b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6a84b2",
  null
  
)

export default component.exports